var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickIcFirstbgYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 468,
    height: 287,
    viewBox: "0 0 468 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7 259.512C56.083 173.756 147.349 25.1738 253.347 116.89C385.844 231.535 222.369 312.677 183.495 226.927C144.622 141.178 174.854 -34.7256 444.403 43.0761",
    stroke: "url(#paint0_linear_4491_1704)",
    strokeWidth: 47,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4491_1704",
    x1: 339.584,
    y1: -23.462,
    x2: 120.819,
    y2: 321.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FD0D6",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#F4DAD7",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0BF33",
    stopOpacity: 0.78
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickIcFirstbgYellow);
export default __webpack_public_path__ + "static/media/stick-ic-firstbg-yellow.b59252179516ee83852033dc3b20432f.svg";
export { ForwardRef as ReactComponent };